export default "__VITE_ASSET__MB1vVpM8__"